import { render, staticRenderFns } from "./WineOfTheMonth.vue?vue&type=template&id=b813195a"
import script from "./WineOfTheMonth.vue?vue&type=script&lang=js"
export * from "./WineOfTheMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports